// extracted by mini-css-extract-plugin
module.exports = {"titleDescription":"propertyDescriptionItem_titleDescription__1XJ6W","line":"propertyDescriptionItem_line__B-TiC","arrow":"propertyDescriptionItem_arrow__SSlJD","open":"propertyDescriptionItem_open__2pAab"};
    if(module.hot) {
      // 1745908359817
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  